<p-dialog
		[(visible)]="visibleLocal"
		[draggable]="true"
		modal="true"
		(onHide)="fermerModal()"
		styleClass="modale-medium"
		[closable]="true">
	<alert [nom]="NOM_ALERTE_RESERVER_BUREAU_MODAL"></alert>
	<p-header>
		<span>{{ 'RESERVER_UN_BUREAU.POPUP_RESERVATION.TITRE' | translate }}</span>
	</p-header>
	<div class="reserver-un-bureau-modal">
		<span>{{ 'RESERVER_UN_BUREAU.POPUP_RESERVATION.MESSAGE_RESERVATION' | translate:{nomBureau: bureau().nom} }} {{ ilot().nom }}</span>
	</div>
	<p-footer>
		<p-button
				[label]="'RESERVER_UN_BUREAU.POPUP_RESERVATION.BTN_RESERVER' | translate"
				type="button"
				icon="pi pi-calendar-plus"
				[loading]="loadingReservation()"
				(click)="reserverBureau()"/>
		<p-button
				[label]="'GLOBAL.BTN_FERMER' | translate"
				type="button"
				styleClass="p-button-link"
				(click)="fermerModal()"/>
	</p-footer>
</p-dialog>
